/*
SELECT '/** @description ' + ISNULL(n.Name, Code) + ' ' + NamespaceClass + CHAR(42) + '/
export const ' + Code + ' = "' + Code + '";'
FROM MuellerHomeOwner.dbo.ExportDefinitions n
ORDER BY Code
 */


/** @description Agent Case Emails Mueller.Exports.Agent.CaseEmailer.AgentCaseEmailsExporter */
export const AGENT_CASE_EMAILS = "AGENT_CASE_EMAILS";

/** @description Agent Notification Mueller.Exports.Agent.Global.AgentNotification */
export const AGENT_NOTIFICATION = "AGENT_NOTIFICATION";

/** @description AIG Completed Cases Mueller.Exports.Webservice.AIG.AIGExporter */
export const AIG_COMPLETED_CASES = "AIG_COMPLETED_CASES";

/** @description AIUA Export Mueller.Exports.Case.Homeowner.AIUA.AIUAExporter */
export const AIUA_EXPORT = "AIUA_EXPORT";

/** @description Allstate 1228 Mueller.Exports.Case.Homeowner.Allstate.Allstate1228Export */
export const ALLSTATE_1228 = "ALLSTATE_1228";

/** @description Allstate CSFB Results Mueller.Exports.Case.Homeowner.Allstate.AllstateCsfbResultsExport */
export const ALLSTATE_CSFB_RESULTS = "ALLSTATE_CSFB_RESULTS";

/** @description Allstate Homecare Checkup Policyholder - Completed Cases Mueller.Exports.Case.Homeowner.Allstate.HomeCareCheckupPolicyholderReportExporter */
export const ALLSTATE_HOMECARE_CHECKUP_POLICYHOLDER___COMPLETED_CASES = "ALLSTATE_HOMECARE_CHECKUP_POLICYHOLDER___COMPLETED_CASES";

/** @description Allstate Vendor Interface - Completed Cases Mueller.Exports.Case.Homeowner.Allstate.AllstateVendorInterfaceExporter */
export const ALLSTATE_VENDOR_INTERFACE___COMPLETED_CASES = "ALLSTATE_VENDOR_INTERFACE___COMPLETED_CASES";

/** @description Appalachian CSV Export Mueller.Exports.Case.Homeowner.Appalachian.AppalachianExport */
export const APPALACHIAN_CSV_EXPORT = "APPALACHIAN_CSV_EXPORT";

/** @description Appraisal Waiver Notification Feature Driven Export Mueller.Exports.Case.Homeowner.FNMA.AppraisalWaiverNotificationFeatureDrivenExporter */
export const APPRAISAL_WAIVER_NOTIFICATION_FEATURE_DRIVEN_EXPORT = "APPRAISAL_WAIVER_NOTIFICATION_FEATURE_DRIVEN_EXPORT";

/** @description AppraisalPort XML Export Mueller.Exports.Case.Homeowner.AppraisalPort.AppraisalPortExporter */
export const APPRAISALPORT_XML_EXPORT = "APPRAISALPORT_XML_EXPORT";

/** @description Auto Owners Commercial Mueller.Exports.Case.Homeowner.AutoOwnersCommercial.AutoOwnersExporter */
export const AUTO_OWNERS_COMMERCIAL = "AUTO_OWNERS_COMMERCIAL";

/** @description Automated Prenotification Call Mueller.Exports.Case.AutomatedPrenotificationCall.AutomatedPrenotificationCall */
export const AUTOMATED_PRENOTIFICATION_CALL = "AUTOMATED_PRENOTIFICATION_CALL";

/** @description BBTExport Mueller.Exports.Case.Homeowner.BBT.BBTExport */
export const BBTEXPORT = "BBTEXPORT";

/** @description Cabrillo Coastal Agent Notification Mueller.Exports.Agent.Homeowner.CabrilloCoastal.CabrilloCoastalAgentExporter */
export const CABRILLO_COASTAL_AGENT_NOTIFICATION = "CABRILLO_COASTAL_AGENT_NOTIFICATION";

/** @description Cabrillo Daily Completed Export Mueller.Exports.Case.Homeowner.Cabrillo.CabrilloDailyCompletedExport */
export const CABRILLO_DAILY_COMPLETED_EXPORT = "CABRILLO_DAILY_COMPLETED_EXPORT";

/** @description Case Emails Mueller.Exports.Case.CaseEmailer.CaseEmailsExporter */
export const CASE_EMAILS = "CASE_EMAILS";

/** @description Case Management Notifications Mueller.Exports.CaseManagement.CaseManagementExporter */
export const CASE_MANAGEMENT_NOTIFICATIONS = "CASE_MANAGEMENT_NOTIFICATIONS";

/** @description Case Reminder Mueller.Exports.Case.Homeowner.CaseReminder.CaseReminderExporter */
export const CASE_REMINDER = "CASE_REMINDER";

/** @description Complex Coverage Completed Cases Mueller.Exports.ComplexCoverage.ComplexCoverageExporter */
export const COMPLEX_COVERAGE_COMPLETED_CASES = "COMPLEX_COVERAGE_COMPLETED_CASES";

/** @description Email PreNotification Mueller.Exports.Case.Homeowner.PreNoteEmailer.EmailPreNotificationsExporter */
export const EMAIL_PRENOTIFICATION = "EMAIL_PRENOTIFICATION";

/** @description Encompass MCOB Results Mueller.Exports.Case.Homeowner.Encompass.EncompassMCOBResultsExporter */
export const ENCOMPASS_MCOB_RESULTS = "ENCOMPASS_MCOB_RESULTS";

/** @description Fannie Mae Field Survey Export Mueller.Exports.Case.Homeowner.FNMA.FNMAFieldSurveyExporter */
export const FANNIE_MAE_FIELD_SURVEY_EXPORT = "FANNIE_MAE_FIELD_SURVEY_EXPORT";

/** @description Fannie Mae Field Survey Feature Driven Export Mueller.Exports.Case.Homeowner.FNMA.FNMAFieldSurveyFeatureDrivenExporter */
export const FANNIE_MAE_FIELD_SURVEY_FEATURE_DRIVEN_EXPORT = "FANNIE_MAE_FIELD_SURVEY_FEATURE_DRIVEN_EXPORT";

/** @description Fannie Mae Phoenix Data Export Mueller.Exports.Case.Homeowner.FNMA.FNMAPhoenixDataExporter */
export const FANNIE_MAE_PHOENIX_DATA_EXPORT = "FANNIE_MAE_PHOENIX_DATA_EXPORT";

/** @description Fannie Mae Phoenix Feature Driven Data Export Mueller.Exports.Case.Homeowner.FNMA.FNMAPhoenixDataFeatureDrivenExporter */
export const FANNIE_MAE_PHOENIX_FEATURE_DRIVEN_DATA_EXPORT = "FANNIE_MAE_PHOENIX_FEATURE_DRIVEN_DATA_EXPORT";

/** @description Field Service Auto QA Mueller.Exports.Case.FieldServiceAutoQA */
export const FIELD_SERVICE_AUTO_QA = "FIELD_SERVICE_AUTO_QA";

/** @description FNMA Batch Notification Export Mueller.Exports.Case.Homeowner.FNMA.FNMABatchNotificationExporter */
export const FNMA_BATCH_NOTIFICATION_EXPORT = "FNMA_BATCH_NOTIFICATION_EXPORT";

/** @description/** FNMA UPD Feature Driven Export Mueller.Exports.Case.Homeowner.UPD.FnmaUpdFeatureDrivenExporter*/
export const FNMA_UPD_FEATURE_DRIVEN_EXPORT = "FNMA_UPD_FEATURE_DRIVEN_EXPORT";

/** @description/** Freddie Mac UPD Feature Driven Export Mueller.Exports.Case.Homeowner.UPD.FreUpdFeatureDrivenExporter*/
export const FREDDIE_MAC_UPD_FEATURE_DRIVEN_EXPORT = "FREDDIE_MAC_UPD_FEATURE_DRIVEN_EXPORT";

/** @description FreddieMac BACE Export Mueller.Exports.Case.Homeowner.FreddieMac.FreddieMacBaceExporter */
export const FREDDIEMAC_BACE_EXPORT = "FREDDIEMAC_BACE_EXPORT";

/** @description Gentrax Completed Cases Mueller.Exports.GentraxCompletedCases.GentraxCompletedCasesExporter */
export const GENTRAX_COMPLETED_CASES = "GENTRAX_COMPLETED_CASES";

/** @description Gentrax New Cases Mueller.Exports.GentraxNewCases.GentraxNewCasesExporter */
export const GENTRAX_NEW_CASES = "GENTRAX_NEW_CASES";

/** @description Harleysville Global FTP Export Mueller.Exports.Case.Global.Harleysville.HarleysvilleGlobalFtpExport */
export const HARLEYSVILLE_GLOBAL_FTP_EXPORT = "HARLEYSVILLE_GLOBAL_FTP_EXPORT";

/** @description Hartford Insurance Fixed-Width Text Batch Exporter Mueller.Exports.Case.Homeowner.HartfordInsurance.HartfordCaMailerFixedWidthTextExport */
export const HARTFORD_INSURANCE_FIXED_WIDTH_TEXT_BATCH_EXPORTER = "HARTFORD_INSURANCE_FIXED_WIDTH_TEXT_BATCH_EXPORTER";

/** @description ICAT Website Upload - Completed Cases Mueller.Exports.Case.Homeowner.ICAT.ICATWebsiteUploadExporter */
export const ICAT_WEBSITE_UPLOAD___COMPLETED_CASES = "ICAT_WEBSITE_UPLOAD___COMPLETED_CASES";

/** @description Liberty XML Exporter Mueller.Exports.Case.Homeowner.Liberty.LibertyXmlExport */
export const LIBERTY_XML_EXPORTER = "LIBERTY_XML_EXPORTER";

/** @description LPS Tab-Delimited Batch Exporter Mueller.Exports.Case.Homeowner.LPS.LpsTabDelimitedTextExport */
export const LPS_TAB_DELIMITED_BATCH_EXPORTER = "LPS_TAB_DELIMITED_BATCH_EXPORTER";

/** @description MacNeil Policyholder - Completed Cases Mueller.Exports.Case.Homeowner.MacNeilGroup.PolicyholderReportExporter */
export const MACNEIL_POLICYHOLDER___COMPLETED_CASES = "MACNEIL_POLICYHOLDER___COMPLETED_CASES";

/** @description Majesco PDF Export Mueller.Exports.Case.Homeowner.NBIC.Majesco.MajescoPdfExporter */
export const MAJESCO_PDF_EXPORT = "MAJESCO_PDF_EXPORT";

/** @description Matrix APV Notifications Mueller.Exports.Case.AutoPolicyVerification.Matrix.MatrixApvNotificationsExporter */
export const MATRIX_APV_NOTIFICATIONS = "MATRIX_APV_NOTIFICATIONS";

/** @description Matrix APV XML Notifications Mueller.Exports.Case.AutoPolicyVerification.Matrix.MatrixApvXmlNotificationsExporter */
export const MATRIX_APV_XML_NOTIFICATIONS = "MATRIX_APV_XML_NOTIFICATIONS";

/** @description Matrix Pre-Notifications Mueller.Exports.Case.Homeowner.Matrix.MatrixPreNotificationsExporter */
export const MATRIX_PRE_NOTIFICATIONS = "MATRIX_PRE_NOTIFICATIONS";

/** @description MiMutualExport Mueller.Exports.Case.Homeowner.MiMutual.MiMutualExport */
export const MIMUTUALEXPORT = "MIMUTUALEXPORT";

/** @description MR2 Batch Export By Customer Mueller.Exports.Case.Homeowner.MR2Batch.ExportBatchByCustomerExporter */
export const MR2_BATCH_EXPORT_BY_CUSTOMER = "MR2_BATCH_EXPORT_BY_CUSTOMER";

/** @description Myriad/iSocket Export Mueller.Exports.Case.Homeowner.Myriad.MyriadExport */
export const MYRIAD_ISOCKET_EXPORT = "MYRIAD_ISOCKET_EXPORT";

/** @description National General PNX Data Export Mueller.Exports.Case.Homeowner.NationalGeneral.NationalGeneralDataExporter */
export const NATIONAL_GENERAL_PNX_DATA_EXPORT = "NATIONAL_GENERAL_PNX_DATA_EXPORT";

/** @description National Grange APV - USAGEXPT.DAT Mueller.Exports.Case.Homeowner.NationalGrange.NationalGrangeAPVExporter */
export const NATIONAL_GRANGE_APV___USAGEXPT_DAT = "NATIONAL_GRANGE_APV___USAGEXPT_DAT";

/** @description Nationwide ALPS - Case Confirmations Mueller.Exports.Case.Homeowner.Nationwide.CaseConfirmations.CaseConfirmationsExporter */
export const NATIONWIDE_ALPS___CASE_CONFIRMATIONS = "NATIONWIDE_ALPS___CASE_CONFIRMATIONS";

/** @description Nationwide ALPS - Completed Cases Mueller.Exports.Case.Homeowner.Nationwide.CompletedCases.CompletedCasesExporter */
export const NATIONWIDE_ALPS___COMPLETED_CASES = "NATIONWIDE_ALPS___COMPLETED_CASES";

/** @description NBIC Azure SQL Data Export Mueller.Exports.Case.Homeowner.NBIC.NBICDataExporter */
export const NBIC_AZURE_SQL_DATA_EXPORT = "NBIC_AZURE_SQL_DATA_EXPORT";

/** @description NBIC Insured Post-notification Mueller.Exports.Case.Homeowner.NBIC.NBICInsuredPostNotification */
export const NBIC_INSURED_POST_NOTIFICATION = "NBIC_INSURED_POST_NOTIFICATION";

/** @description Occidental - Export Mueller.Exports.Case.Homeowner.Occidental.OccidentalExport */
export const OCCIDENTAL___EXPORT = "OCCIDENTAL___EXPORT";

/** @description PacificSpecialty Mueller.Exports.Case.Homeowner.PacificSpecialty.PacificSpecialtyExport */
export const PACIFICSPECIALTY = "PACIFICSPECIALTY";

/** @description PDF Exporter Mueller.Exports.Case.Homeowner.PDFExport.PDFExporter */
export const PDF_EXPORTER = "PDF_EXPORTER";

/** @description Phoenix Cases XML Data Export Mueller.Exports.Case.Homeowner.PhoenixCase.PhoenixCaseXMLExporter */
export const PHOENIX_CASES_XML_DATA_EXPORT = "PHOENIX_CASES_XML_DATA_EXPORT";

/** @description Plymouth Rock - Export Mueller.Exports.Case.Homeowner.PlymouthRock.PlymouthRockExport */
export const PLYMOUTH_ROCK___EXPORT = "PLYMOUTH_ROCK___EXPORT";

/** @description Preferred Appointments Mueller.Exports.Case.PreferredAppointments.PreferredAppointmentReminders */
export const PREFERRED_APPOINTMENTS = "PREFERRED_APPOINTMENTS";

/** @description SafecoCaseXmlExporter Mueller.Exports.Case.Homeowner.Safeco.SafecoCaseXmlExporter */
export const SAFECOCASEXMLEXPORTER = "SAFECOCASEXMLEXPORTER";

/** @description SafecoLHExporter Mueller.Exports.Case.Homeowner.Safeco.LH.SafecoLHExporter */
export const SAFECOLHEXPORTER = "SAFECOLHEXPORTER";

/** @description Selective Export Mueller.Exports.Case.Homeowner.Selective.SelectiveExporter */
export const SELECTIVE_EXPORT = "SELECTIVE_EXPORT";

/** @description ShoreOne Export Mueller.Exports.Case.Homeowner.ShoreOne.ShoreOneExport */
export const SHOREONE_EXPORT = "SHOREONE_EXPORT";

/** @description Solidifi XML Export Mueller.Exports.Case.Homeowner.Solidifi.SolidifiXmlExport */
export const SOLIDIFI_XML_EXPORT = "SOLIDIFI_XML_EXPORT";

/** @description Travelers Millenium Export Mueller.Exports.Case.Homeowner.Travelers.MilleniumExport */
export const TRAVELERS_MILLENIUM_EXPORT = "TRAVELERS_MILLENIUM_EXPORT";

/** @description Travelers XML Export Mueller.Exports.Case.Homeowner.Travelers.TravelersExporter */
export const TRAVELERS_XML_EXPORT = "TRAVELERS_XML_EXPORT";

/** @description/** UPD Field Survey Feature Driven Export Mueller.Exports.Case.Homeowner.UPD.UPDFieldSurveyFeatureDrivenExporter*/
export const UPD_FIELD_SURVEY_FEATURE_DRIVEN_EXPORT = "UPD_FIELD_SURVEY_FEATURE_DRIVEN_EXPORT";

/** @description USAA 360 XML Export Mueller.Exports.Case.Homeowner.USAA360.UsaaXmlExporter */
export const USAA_360_XML_EXPORT = "USAA_360_XML_EXPORT";

/** @description USAA Pipe Delimited Mitigation Data Exporter Mueller.Exports.Case.Homeowner.USAA360.UsaaMitigationDataExporter */
export const USAA_PIPE_DELIMITED_MITIGATION_DATA_EXPORTER = "USAA_PIPE_DELIMITED_MITIGATION_DATA_EXPORTER";

/** @description USAA XML Export Mueller.Exports.Case.Homeowner.USAA.UsaaXmlExporter */
export const USAA_XML_EXPORT = "USAA_XML_EXPORT";

/** @description Utica National Agent Appointment Set Notifications Mueller.Exports.Agent.Homeowner.UticaNational.Appointment.UticaNationalAgentApptSetExporter */
export const UTICA_NATIONAL_AGENT_APPOINTMENT_SET_NOTIFICATIONS = "UTICA_NATIONAL_AGENT_APPOINTMENT_SET_NOTIFICATIONS";

/** @description Utilant Mueller.Exports.Case.Homeowner.Utilant.UtilantExport */
export const UTILANT = "UTILANT";

/** @description UwmCompletionPendingExport Mueller.Exports.Case.Homeowner.UWM.UwmCompletionPendingExport */
export const UWMCOMPLETIONPENDINGEXPORT = "UWMCOMPLETIONPENDINGEXPORT";

/** @description UwmDisasterAreaExport Mueller.Exports.Case.Homeowner.UWM.UwmDisasterAreaExport */
export const UWMDISASTERAREAEXPORT = "UWMDISASTERAREAEXPORT";

/** @description UwmExport Mueller.Exports.Case.Homeowner.UWM.UwmExport */
export const UWMEXPORT = "UWMEXPORT";

/** @description ValueNet Completed Cases Mueller.Exports.Webservice.ValueNet.ValueNetExporter */
export const VALUENET_COMPLETED_CASES = "VALUENET_COMPLETED_CASES";

/** @description Virginia Property Fixed File Mueller.Exports.Case.Homeowner.VirginiaProperty.VirginiaPropertyExport */
export const VIRGINIA_PROPERTY_FIXED_FILE = "VIRGINIA_PROPERTY_FIXED_FILE";

/** @description Wait Thirty Seconds Export Mueller.Exports.Example.WaitThirtySecondsExport */
export const WAIT_THIRTY_SECONDS_EXPORT = "WAIT_THIRTY_SECONDS_EXPORT";

/** @description WestAmcExport Mueller.Exports.Case.Homeowner.WestAmc.WestAmcExport */
export const WESTAMCEXPORT = "WESTAMCEXPORT";

